// extracted by mini-css-extract-plugin
export var anchorContainer = "askQuestionWidget-module--anchorContainer--YqaMR";
export var bodyText = "askQuestionWidget-module--bodyText--rccy8";
export var ctaWidgetContainer = "askQuestionWidget-module--ctaWidgetContainer--VYSvR";
export var headerText = "askQuestionWidget-module--headerText--aE5vj";
export var leftSideTextContainer = "askQuestionWidget-module--leftSideTextContainer--2hV+r";
export var leftStripe = "askQuestionWidget-module--leftStripe--rqK3M";
export var mobileFullWidth = "askQuestionWidget-module--mobileFullWidth--CQhs7";
export var pinkCta = "askQuestionWidget-module--pinkCta--Va4Sa";